import script from "./CalidErrorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CalidErrorPage.vue?vue&type=script&setup=true&lang=js"

import "./CalidErrorPage.vue?vue&type=style&index=0&id=ba87f9f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba87f9f0"]])

export default __exports__